import React, { useEffect, useState, useRef } from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Excelldownload = ({ data, data1 }) => {
  return (
    <ExcelFile element={<Button type="primary">Download Data</Button>}>
      <ExcelSheet data={data} name="All Invoices">
        <ExcelColumn label="Barcode" value="barcode" />
        <ExcelColumn label="Batch" value="batch_no" />
        <ExcelColumn label="Product" value="product_code" />
        <ExcelColumn label="Category" value="category" />
        <ExcelColumn label="Brand" value="Brand_name" />
        {/* <ExcelColumn label="Color" value="color" /> */}
        <ExcelColumn label="Variation" value="Attribute_details" />
        {/* <ExcelColumn label="Bill" value="bill" /> */}
        <ExcelColumn label="Warehouse" value="Warehouse_name" />
        <ExcelColumn label="Quantity" value="quantity" />
        <ExcelColumn label="Purchase price" value="purchase_price" />
        <ExcelColumn label="Selling price" value="selling_price" />
        <ExcelColumn label="Audit Count" value="audit_quantity" />
        <ExcelColumn label="Audit status" value="audit_health_stat" />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default Excelldownload;
